/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListToolsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tool_endpoint_messages.pb'
import {ListToolsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tool_endpoint_messages.pb'


export const listTools = (request: ListToolsRequest, options?: CashRequestOptions) => post<ListToolsRequest, ListToolsResponse>("/2.0/cash/list-tools", request, {...options, rejectOnError: true })